"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var abandoned_icon_1 = require("../../../svg/chart-keys/abandoned.icon");
var connectedAfterQueueing_icon_1 = require("../../../svg/chart-keys/connectedAfterQueueing.icon");
var failed_icon_1 = require("../../../svg/chart-keys/failed.icon");
var immediatelyConnected_icon_1 = require("../../../svg/chart-keys/immediatelyConnected.icon");
var routedAway_icon_1 = require("../../../svg/chart-keys/routedAway.icon");
var timedOut_icon_1 = require("../../../svg/chart-keys/timedOut.icon");
var other_icon_1 = require("../../../svg/chart-keys/other.icon");
var core_components_1 = require("@securityproducts/core-components");
var inlineMetric_1 = require("./inline-metric/inlineMetric");
var totalCalls_styles_1 = require("./totalCalls.styles");
var core_components_2 = require("@securityproducts/core-components");
var react_1 = require("react");
var totalCalls_i18n_1 = require("./totalCalls.i18n");
function TotalCalls(props) {
    var _a = react_1.useState(null), highlightedMetric = _a[0], setHighlightedMetric = _a[1];
    var strings = core_components_2.useLocalisation(totalCalls_i18n_1.totalCallsTranslations, props.language);
    var titles = [
        {
            id: "immediatelyConnected",
            name: strings.immediatelyConnected,
            icon: React.createElement(immediatelyConnected_icon_1.ImmediatelyConnectedIcon, null),
        },
        {
            id: "connectedAfterQueueing",
            name: strings.connectedAfterQueueing,
            icon: React.createElement(connectedAfterQueueing_icon_1.ConnectedAfterQueueingIcon, null),
        },
        {
            id: "routedAway",
            name: strings.routedAway,
            icon: React.createElement(routedAway_icon_1.RoutedAwayIcon, null),
        },
        {
            id: "timedOut",
            name: strings.timedOut,
            icon: React.createElement(timedOut_icon_1.TimedOutIcon, null),
        },
        {
            id: "abandoned",
            name: strings.abandoned,
            icon: React.createElement(abandoned_icon_1.AbandonedIcon, null),
        },
        {
            id: "failedDueToMaxCallers",
            name: strings.failedDueTo,
            icon: React.createElement(failed_icon_1.FailedIcon, null),
        },
        {
            id: "other",
            name: strings.other,
            icon: React.createElement(other_icon_1.OtherIcon, null),
        },
    ];
    function getTitle(id) {
        return titles.find(function (title) { return title.id === id; });
    }
    var data = [
        {
            value: props.immediatelyConnected ? props.immediatelyConnected : 0,
            label: strings.immediatelyConnected,
            colour: "#66af3d",
        },
        {
            value: props.connectedAfterQueueing ? props.connectedAfterQueueing : 0,
            label: strings.connectedAfterQueueing,
            colour: "#9ed350",
        },
        {
            value: props.routedAway ? props.routedAway : 0,
            label: strings.routedAway,
            colour: "#e2e044",
        },
        {
            value: props.timedOut ? props.timedOut : 0,
            label: strings.timedOut,
            colour: "#f0a029",
        },
        {
            value: props.abandoned ? props.abandoned : 0,
            label: strings.abandoned,
            colour: "#a5d5ee",
        },
        {
            value: props.failedDueToMaxCallers ? props.failedDueToMaxCallers : 0,
            label: strings.failedDueTo,
            colour: "#09a3e7",
        },
        {
            value: props.other ? props.other : 0,
            label: strings.other,
            colour: "#0085c7",
        },
    ];
    function highlightMetric(series) {
        // @ts-ignore
        var thing = series.w.config.labels[series.seriesIndex];
        setHighlightedMetric(thing);
        return "";
    }
    function cleanUpHoverStates() {
        setHighlightedMetric(null);
    }
    var values = data.map(function (datum) { return datum.value; });
    var totalCount = values.reduce(function (total, current) { return (total += current); });
    return (React.createElement(core_components_1.ChartSection, { heading: strings.totalCalls, id: "total-calls" },
        React.createElement("div", { className: totalCalls_styles_1.wrapper },
            getTotal(props, totalCalls_styles_1.totalMedium, strings),
            React.createElement("div", { className: totalCalls_styles_1.chart, onMouseLeave: cleanUpHoverStates, id: "total-calls-chart" },
                React.createElement(core_components_1.DonutChart, { id: "total-calls-chart", data: data, width: 200, onShowTooltip: highlightMetric, sizes: [
                        {
                            maxWidth: 700,
                            chartWidth: 196,
                        },
                        {
                            maxWidth: 2000,
                            chartWidth: 240,
                        },
                    ] }),
                getTotal(props, totalCalls_styles_1.totalSmall, strings)),
            React.createElement("div", { className: totalCalls_styles_1.detail, id: "total-calls-details" },
                React.createElement(inlineMetric_1.InlineMetric, { id: "total-calls-immediately-connected", text: getTitle("immediatelyConnected").name, value: props.immediatelyConnected, total: totalCount, tooltip: strings.immediatelyConnectedTooltip, iconShape: "circle", iconFill: "#66af3d", iconStroke: "#66af3d", highlighted: highlightedMetric === strings.immediatelyConnected }),
                React.createElement(inlineMetric_1.InlineMetric, { id: "total-calls-connected-after-queueing", text: getTitle("connectedAfterQueueing").name, value: props.connectedAfterQueueing, total: totalCount, tooltip: strings.connectedAfterQueueingTooltip, iconShape: "circle", iconFill: "#9ed350", iconStroke: "#9ed350", highlighted: highlightedMetric === strings.connectedAfterQueueing }),
                React.createElement(inlineMetric_1.InlineMetric, { id: "total-calls-routed-away", text: getTitle("routedAway").name, value: props.routedAway, total: totalCount, tooltip: strings.routedAwayTooltip, iconShape: "circle", iconFill: "#e2e044", iconStroke: "#e2e044", highlighted: highlightedMetric === strings.routedAway }),
                React.createElement(inlineMetric_1.InlineMetric, { id: "total-calls-timed-out", text: getTitle("timedOut").name, value: props.timedOut, total: totalCount, tooltip: strings.timedOutTooltip, iconShape: "circle", iconFill: "#f0a029", iconStroke: "#f0a029", highlighted: highlightedMetric === strings.timedOut }),
                React.createElement(inlineMetric_1.InlineMetric, { id: "total-calls-abandoned", text: getTitle("abandoned").name, value: props.abandoned, total: totalCount, tooltip: strings.abandonedTooltip, iconShape: "circle", iconFill: "#acdef8", iconStroke: "#acdef8", highlighted: highlightedMetric === strings.abandoned }),
                React.createElement(inlineMetric_1.InlineMetric, { id: "total-calls-failed", text: getTitle("failedDueToMaxCallers").name, value: props.failedDueToMaxCallers, total: totalCount, tooltip: strings.failedDueToTooltip, iconShape: "circle", iconFill: "#09a3e7", iconStroke: "#09a3e7", highlighted: highlightedMetric === strings.failedDueTo }),
                React.createElement(inlineMetric_1.InlineMetric, { id: "total-calls-other", text: getTitle("other").name, value: props.other, total: totalCount, tooltip: strings.otherTooltip, iconShape: "circle", iconFill: "#0085c7", iconStroke: "#0085c7", highlighted: highlightedMetric === strings.other })))));
}
exports.TotalCalls = TotalCalls;
TotalCalls.defaultProps = {
    immediatelyConnected: 0,
    connectedAfterQueueing: 0,
    routedAway: 0,
    timedOut: 0,
    abandoned: 0,
    failedDueToMaxCallers: 0,
    other: 0,
};
function getTotal(props, className, strings) {
    var total = Object.values(props).reduce(function (accumulator, currentValue) {
        if (currentValue > 0) {
            return accumulator + currentValue;
        }
        else {
            return accumulator;
        }
    });
    if (isNaN(total) || total === 0) {
        return (React.createElement("div", { className: className + " " + totalCalls_styles_1.noDataMessage, id: "total-calls-total" },
            strings.noData,
            React.createElement("br", null),
            " ",
            strings.available));
    }
    else {
        return (React.createElement("div", { className: className, id: "total-calls-total" },
            total.toLocaleString(),
            React.createElement("div", { className: totalCalls_styles_1.callsLabel }, strings.calls)));
    }
}
